import { useTranslation } from 'react-i18next';

import { APPLICANT_FILTERS, type ApplicantFilter } from '~/features/whatsapp/utils/resolveApplicantChats';
import { cn } from '~/utils/cnTailwind';

type Props = {
    activeFilter: ApplicantFilter;
    onChange: (filter: ApplicantFilter) => void;
};

const FILTERS: Array<ApplicantFilter> = [APPLICANT_FILTERS.KN1, APPLICANT_FILTERS.KN2, APPLICANT_FILTERS.BOTH];

export const ApplicantSwitcher = ({ activeFilter, onChange }: Props) => {
    const { t } = useTranslation();

    return (
        <div className="flex shrink-0 gap-1 border-b border-outline-light px-4 py-2" data-testid="applicant-switcher">
            {FILTERS.map((filter) => (
                <button
                    key={filter}
                    type="button"
                    onClick={() => onChange(filter)}
                    className={cn(
                        'rounded-full px-2.5 py-1 text-xs font-semibold',
                        activeFilter === filter ? 'bg-midnight text-white' : 'bg-grey-light text-grey',
                    )}
                >
                    {t(`WHATSAPP_CHAT.APPLICANT_SWITCHER.${filter}`)}
                </button>
            ))}
        </div>
    );
};
